// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"59d96f04","219":"e940525e","453":"79c55585"}[chunkId] + ".chunk.js";
};